import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showOrgUnitSupportContactModal } from '../../../../actions/modal.js';
import { updateOrgUnitSupportContact } from '../../../../actions/organisation.js';
import Info from '../../info';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { Icon } from 'semantic-ui-react';

export default function SupportContactRightBottomPanel(props) {
  const dispatch = useDispatch();
  const [updatingSupportContact, setUpdatingSupportContact] = useState(false);

  useEffect(() => {
    // Force validation of the input fields
    let validation = () => {
      forceValidation(undefined, undefined, 'orgSupportContactModal');
    };
    setTimeout(validation, 50);
  }, []);

  const closeModal = () => {
    dispatch(showOrgUnitSupportContactModal(false));
  };

  const clickSaveBtn = (event) => {
    if (!event.isTrusted) return;
    if (!event.target.className.includes('disable')) {
      saveChanges();
    }
  };

  const saveChanges = () => {
    setUpdatingSupportContact(true);

    let cb = (openModal) => {
      setUpdatingSupportContact(false);
      dispatch(showOrgUnitSupportContactModal(openModal));
    };
    dispatch(updateOrgUnitSupportContact(props.selectedOrgUnit, props.updatedOrgUnitSupportContactForm, cb));
  };

  const saveClasses =
    'ui disable labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull';
  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className="ui actions mrbl mrtxxs max-width">
          <button
            type="button"
            tabIndex="6"
            data-group="orgSupportContactModal"
            onClick={clickSaveBtn}
            className={updatingSupportContact ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark  icon" />
          </button>
          <button
            type="button"
            tabIndex="7"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="ui actions mrbl max-width mrtxxs ">
          <button
            tabIndex="6"
            onClick={closeModal}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
      <div className="mrtl">
        {props.updateOrView == 'update' ? (
          <Info
            paragraphs={[
              APP.LANGUAGE.OrgUnitSupportContact.InfoOnTheRightOne,
              APP.LANGUAGE.OrgUnitSupportContact.InfoOnTheRightTwo,
            ]}
          />
        ) : (
          <Info paragraphs={[APP.LANGUAGE.OrgUnitSupportContact.InfoOnTheRightOne]} />
        )}
      </div>
    </div>
  );
}
